import React, { memo } from 'react'
import { Handle } from '@xyflow/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faChevronDown,
    faCircleMinus,
    faPenToSquare,
    faSquarePlus,
    faTrash,
} from '@fortawesome/free-solid-svg-icons'

// تعریف نود جدید با دو ایکون
export const DepartmentNode = ({ data }) => {
    const {
        label,
        handlerAddDepartment,
        onClickIcon2,
        onClickChildDepartment,
        handlerEditDepartment,
        handlerDeleteDepartment,
    } = data

    return (
        <div className="departmentNode !bg-indigo-700 !shadow-2xl">
            <div
                className="departmentNode-label"
                onClick={onClickChildDepartment}
            >
                <FontAwesomeIcon icon={faChevronDown} /> {label}{' '}
            </div>
            <div className="departmentNode-box-icons">
                <span
                    onClick={() => {
                        handlerAddDepartment()
                    }}
                    className="departmentNode-department"
                >
                    <FontAwesomeIcon icon={faSquarePlus} />
                </span>

                <span
                    className="departmentNode-trash"
                    onClick={handlerDeleteDepartment}
                >
                    <FontAwesomeIcon icon={faTrash} />
                </span>
                <span
                    className="departmentNode-trash !text-blue-200"
                    onClick={handlerEditDepartment}
                >
                    <FontAwesomeIcon icon={faPenToSquare} />
                </span>
            </div>
            <Handle type="source" position="bottom" />
            <Handle type="target" position="top" />
        </div>
    )
}

export default memo(DepartmentNode)
